import feathers from '@feathersjs/client';
import { cacheBefore, cacheAfter } from 'src/feathers/hooks';
const { GeneralError } = feathers.errors;

class Service {
  constructor(options) {
    this.options = options || {};
  }

  setup(app) {
    this.directionsService = new window.google.maps.DirectionsService();
  }

  async find(params) {
    const googleParams = {
      travelMode: window.google.maps.TravelMode.DRIVING,
      ...params.query
    };
    return new Promise((resolve, reject) => {
      this.directionsService.route(googleParams, (response, status) => {
        if (status !== 'OK') {
          reject(
            new GeneralError(
              'There was an error from Google calculating the directions.',
              { status }
            )
          );
        } else {
          resolve(response);
        }
      });
    });
  }
}

export default (app) => {
  app.use('google/directions', new Service());
  const service = app.service('google/directions');

  service.hooks({
    before: {
      all: [],
      find: [cacheBefore],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [],
      find: [cacheAfter],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
